(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["free-delivery-destinations"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('free-delivery-destinations')) {
    customElements.define(
      'free-delivery-destinations',
      class FreeDeliveryDestinations extends HTMLElement {
        connectedCallback() {
          const mapElement = this.querySelector('[data-free-delivery-map]');
          const template = this.querySelector('[data-free-delivery-countries]');
          const select = this.querySelector('select');
          const form = this.querySelector('form');
          const countryInput = this.querySelector('[data-country-code-input]');
          const estimate = this.querySelector('[data-delivery-estimate]');
          const dateRange = this.querySelector('[data-delivery-date-range]');

          if (!(mapElement instanceof HTMLScriptElement)) return;
          if (!(template instanceof HTMLTemplateElement)) return;
          if (!(select instanceof HTMLSelectElement)) return;
          if (!(form instanceof HTMLFormElement)) return;
          if (!(countryInput instanceof HTMLInputElement)) return;
          if (!(estimate instanceof HTMLElement)) return;
          if (!(dateRange instanceof HTMLElement)) return;

          try {
            this.deliveryMap = JSON.parse(mapElement.textContent || '{}');
          } catch {
            this.deliveryMap = {};
          }

          this.countryOptions = Array.from(template.content.querySelectorAll('option'));
          this.selectElement = select;
          this.formElement = form;
          this.countryInput = countryInput;
          this.estimateElement = estimate;
          this.dateRangeElement = dateRange;
          this.currentCountryCode = this.dataset.currentCountryCode || '';
          this.render(this.dataset.selectedVariantId || '');

          this.variantChangeHandler = this.handleVariantChange.bind(this);
          this.countryChangeHandler = this.handleCountryChange.bind(this);
          document.addEventListener('change', this.variantChangeHandler);
          this.selectElement.addEventListener('change', this.countryChangeHandler);
        }

        disconnectedCallback() {
          if (this.variantChangeHandler) {
            document.removeEventListener('change', this.variantChangeHandler);
          }

          if (this.countryChangeHandler && this.selectElement) {
            this.selectElement.removeEventListener('change', this.countryChangeHandler);
          }
        }

        handleCountryChange() {
          if (!this.selectElement || !this.formElement || !this.countryInput) return;
          if (!this.selectElement.value) return;

          this.updateDeliveryEstimate(this.selectElement.selectedOptions[0]);
          this.countryInput.value = this.selectElement.value;

          if (typeof this.formElement.requestSubmit === 'function') {
            this.formElement.requestSubmit();
          } else {
            this.formElement.submit();
          }
        }

        handleVariantChange(event) {
          if (!(event.target instanceof HTMLElement)) return;
          if (!event.target.closest('variant-picker')) return;

          let variantId = event.target.dataset.variantId || '';

          if (event.target instanceof HTMLSelectElement) {
            variantId = event.target.options[event.target.selectedIndex]?.dataset.variantId || variantId;
          }

          if (variantId) {
            this.render(variantId);
            return;
          }

          window.setTimeout(() => {
            const productComponent = this.closest('product-component');
            const variantInput = productComponent?.querySelector('input[name="id"]');
            if (variantInput instanceof HTMLInputElement) {
              this.render(variantInput.value);
            }
          }, 500);
        }

        render(variantId) {
          if (!this.selectElement) return;

          const countries = this.deliveryMap?.[String(variantId)] || [];
          this.selectElement.replaceChildren();

          for (const option of this.countryOptions || []) {
            if (countries.includes(option.value)) {
              this.selectElement.append(option.cloneNode(true));
            }
          }

          if (this.selectElement.options.length === 0) {
            this.hideDeliveryEstimate();
            this.hidden = true;
            return;
          }

          const currentCountryOption = Array.from(this.selectElement.options).find(
            (option) => option.value === this.currentCountryCode
          );

          if (currentCountryOption) {
            currentCountryOption.selected = true;
            this.updateDeliveryEstimate(currentCountryOption);
          } else {
            const placeholder = new Option(this.dataset.placeholder || 'Select a delivery country', '', true, true);
            placeholder.disabled = true;
            this.selectElement.prepend(placeholder);
            this.hideDeliveryEstimate();
          }

          this.hidden = false;
        }

        updateDeliveryEstimate(option) {
          if (!(option instanceof HTMLOptionElement)) {
            this.hideDeliveryEstimate();
            return;
          }

          const countryName = option.dataset.countryName || '';
          if (!countryName) {
            this.hideDeliveryEstimate();
            return;
          }

          this.dateRangeElement.textContent = this.getDeliveryDateRange();
          this.estimateElement.hidden = false;
        }

        getDeliveryDateRange() {
          const today = new Date();
          today.setHours(0, 0, 0, 0);

          const earliestDate = new Date(today);
          earliestDate.setDate(today.getDate() + 8);

          const latestDate = new Date(today);
          latestDate.setDate(today.getDate() + 15);

          const includeYear =
            earliestDate.getFullYear() !== latestDate.getFullYear() ||
            earliestDate.getFullYear() !== today.getFullYear();
          const formatOptions = { month: 'short', day: 'numeric' };

          if (includeYear) {
            formatOptions.year = 'numeric';
          }

          const formatter = new Intl.DateTimeFormat(
            document.documentElement.lang || navigator.language || 'en',
            formatOptions
          );

          return `${formatter.format(earliestDate)} – ${formatter.format(latestDate)}`;
        }

        hideDeliveryEstimate() {
          if (this.estimateElement) {
            this.estimateElement.hidden = true;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-share"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-share')) {
    customElements.define(
      'product-share',
      class ProductShare extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('[data-share-button]');
          this.label = this.querySelector('[data-share-button-label]');
          this.status = this.querySelector('[data-share-status]');

          if (!(this.button instanceof HTMLButtonElement)) return;
          if (!(this.label instanceof HTMLElement)) return;
          if (!(this.status instanceof HTMLElement)) return;

          this.shareHandler = this.handleShare.bind(this);
          this.button.addEventListener('click', this.shareHandler);
        }

        disconnectedCallback() {
          if (this.button && this.shareHandler) {
            this.button.removeEventListener('click', this.shareHandler);
          }

          if (this.resetTimer) {
            window.clearTimeout(this.resetTimer);
          }
        }

        async handleShare() {
          const url = window.location.href || this.dataset.shareUrl || '';
          const title = this.dataset.shareTitle || document.title;

          if (navigator.share) {
            try {
              await navigator.share({ title, url });
              return;
            } catch (error) {
              if (error instanceof DOMException && error.name === 'AbortError') return;
            }
          }

          const copied = await this.copyLink(url);
          if (!copied) return;

          const copiedLabel = this.dataset.copiedLabel || 'Link copied';
          const shareLabel = this.dataset.shareLabel || 'Share';

          this.label.textContent = copiedLabel;
          this.status.textContent = copiedLabel;

          this.resetTimer = window.setTimeout(() => {
            this.label.textContent = shareLabel;
            this.status.textContent = '';
          }, 2500);
        }

        async copyLink(url) {
          try {
            await navigator.clipboard.writeText(url);
            return true;
          } catch {
            try {
              const input = document.createElement('textarea');
              input.value = url;
              input.setAttribute('readonly', '');
              input.style.position = 'fixed';
              input.style.opacity = '0';
              document.body.append(input);
              input.select();
              const copied = document.execCommand('copy');
              input.remove();
              return copied;
            } catch {
              return false;
            }
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
